<template>
  <v-container fill-height>
    <v-row justify="center">
      <v-col cols="12">
        <v-card class="card" color="primary" :loading="loading">
          <v-card-title>Tabla de personal</v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="4">
                  <v-text-field
                    label="Buscar personal por nombre o CUIP"
                    v-model="searchPersonal"
                    rounded
                    filled
                    dense
                    color="secondary"
                    append-icon="mdi-magnify"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-data-table :headers="headers" :items="filteredPersonal" class="transparent" :loading="loading">
                    <template v-slot:[`item.nombre`]="{ item }">
                      <div class="d-inline-flex align-center pt-4">
                        <v-avatar size="48" class="mr-4">
                          <v-img :src="item.foto"></v-img>
                        </v-avatar>
                        <div>
                          <div class="text-caption font-weight-bold">
                            {{ getFullName(item) }}
                          </div>
                          <div class="text-caption">
                            {{ item.CUIP }}
                          </div>
                          <div class="text-caption" v-if="item.CatPuestoDependencia">
                            {{ item.CatPuestoDependencia.catPuesto.puesto }}
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-slot:[`item.susceptible`]="{ item }">
                      <v-icon v-if="susceptibleCup(item)" color="success">mdi-check-circle</v-icon>
                      <v-icon v-else color="error">mdi-alert-circle</v-icon>
                    </template>
                    <template v-slot:[`item.vigenciaEvaluacionC3`]="{ item }">
                      <div
                        :class="
                          tieneC3Vigente(item.vigenciaEvaluacionC3)
                            ? 'success--text font-weight-bold'
                            : 'error--text font-weight-bold'
                        "
                      >
                        {{ item.vigenciaEvaluacionC3 }}
                      </div>
                    </template>
                    <template v-slot:[`item.vigenciaFormacionInicial`]="{ item }">
                      <div
                        :class="
                          tieneC3Vigente(item.vigenciaFormacionInicial)
                            ? 'success--text font-weight-bold'
                            : 'error--text font-weight-bold'
                        "
                      >
                        {{ item.vigenciaFormacionInicial }}
                      </div>
                    </template>
                    <template v-slot:[`item.vigenciaCompetenciasBasicas`]="{ item }">
                      <div
                        :class="
                          tieneC3Vigente(item.vigenciaCompetenciasBasicas)
                            ? 'success--text font-weight-bold'
                            : 'error--text font-weight-bold'
                        "
                      >
                        {{ item.vigenciaCompetenciasBasicas }}
                      </div>
                    </template>
                    <template v-slot:[`item.vigenciaCup`]="{ item }">
                      <div
                        :class="
                          tieneC3Vigente(item.vigenciaCup)
                            ? 'success--text font-weight-bold'
                            : 'error--text font-weight-bold'
                        "
                      >
                        {{ item.vigenciaCup }}
                      </div>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  async mounted() {
    this.loading = true
    if (this.personal.length == 0) {
      // await this.fetchPersonalPagination({
      //     page: this.options.page,
      //     rows: this.options.itemsPerPage,
      // })
      await this.fetchPersonalByDependencia(2)
    }
    this.loading = false
  },

  data() {
    return {
      loading: false,
      searchPersonal: '',

      headers: [
        { text: 'Nombre', value: 'nombre', sortable: false },
        { text: 'Susceptible a CUP', value: 'susceptible', align: 'center', sortable: false },
        { text: 'Vigencia C3', value: 'vigenciaEvaluacionC3', align: 'center', sortable: false },
        { text: 'Vigencia Formación Inicial', value: 'vigenciaFormacionInicial', align: 'center', sortable: false },
        { text: 'Vigencia Comp. Básicas', value: 'vigenciaCompetenciasBasicas', align: 'center', sortable: false },
        { text: 'Vigencia CUP', value: 'vigenciaCup', align: 'center', sortable: false },
      ],
      options: {
        page: 1,
        itemsPerPage: 5,
      },
    }
  },

  computed: {
    ...mapGetters('personal', {
      personal: 'getFullPersonal',
    }),

    filteredPersonal() {
      if (this.personal.length > 0) {
        return this.personal.filter((elemento) => {
          return (
            this.getFullName(elemento).toLowerCase().indexOf(this.searchPersonal.toLowerCase()) >= 0 ||
            elemento.CUIP.toLowerCase().indexOf(this.searchPersonal.toLowerCase()) >= 0
          )
        })
      } else return []
    },
  },

  methods: {
    ...mapActions('personal', ['fetchPersonalPagination', 'fetchPersonalByDependencia']),

    susceptibleCup(personal) {
      if (
        this.tieneC3Vigente(personal.vigenciaEvaluacionC3) &&
        this.tieneC3Vigente(personal.vigenciaFormacionInicial) &&
        this.tieneC3Vigente(personal.vigenciaCompetenciasBasicas) &&
        this.tieneC3Vigente(personal.vigenciaCup)
      ) {
        return true
      } else return false
    },
  },
}
</script>

<style scoped>
/* Estilos modernos para Dashboard Desarrollo Profesional - Tema Oscuro */
.card {
  backdrop-filter: blur(10px);
  border: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.1);
  transition: all 0.3s ease;
}

.card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.03),
    rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.01)
  );
  pointer-events: none;
  z-index: 0;
}

.card:hover {
  transform: translateY(-2px);
  border-color: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.4);
  box-shadow: 0 12px 48px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.15);
}

.card:hover::before {
  background: linear-gradient(
    135deg,
    rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.05),
    rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.02)
  );
}

/* Card title & text */
::v-deep .v-card-title {
  color: #e0e0e0 !important;
  padding: 20px 24px !important;
  position: relative;
  z-index: 1;
  font-weight: 600 !important;
  text-transform: uppercase;
  font-size: 1.125rem !important;
}

::v-deep .v-card-text {
  color: #e0e0e0 !important;
  position: relative;
  z-index: 1;
}

/* Data table */
::v-deep .v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
  position: relative;
  z-index: 1;
}

::v-deep .v-data-table__wrapper {
  border-radius: 12px;
  overflow: hidden;
}

/* Headers */
::v-deep .v-data-table-header {
  position: relative;
}

::v-deep .v-data-table-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--v-secondary-base);
  opacity: 0.15;
  pointer-events: none;
  z-index: 0;
}

::v-deep .v-data-table-header th {
  color: #e0e0e0 !important;
  font-weight: 700 !important;
  font-size: 0.75rem !important;
  text-transform: uppercase;
  letter-spacing: 1px;
  border-bottom: 2px solid var(--v-secondary-base) !important;
  padding: 16px !important;
  position: relative;
  z-index: 1;
}

/* Rows */
::v-deep .v-data-table tbody tr {
  transition: all 0.2s ease;
  position: relative;
  cursor: pointer;
}

::v-deep .v-data-table tbody tr:hover {
  background: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.12) !important;
  transform: scale(1.005);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

::v-deep .v-data-table tbody td {
  color: #e0e0e0 !important;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.08) !important;
  padding: 14px 16px !important;
  position: relative;
  z-index: 1;
  font-size: 0.9375rem;
}

/* Avatares */
::v-deep .v-avatar {
  border: 2px solid var(--v-secondary-base);
  transition: all 0.3s ease;
}

::v-deep tr:hover .v-avatar {
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.4);
}

/* Iconos */
::v-deep .v-icon {
  transition: all 0.3s ease;
}

::v-deep tr:hover .v-icon {
  transform: scale(1.2);
}

::v-deep .v-icon.success--text {
  color: #26de81 !important;
  filter: drop-shadow(0 2px 8px rgba(38, 222, 129, 0.4));
}

::v-deep .v-icon.error--text {
  color: #fc5c65 !important;
  filter: drop-shadow(0 2px 8px rgba(252, 92, 101, 0.4));
}

/* Text colors */
.text-caption {
  color: #e0e0e0 !important;
}

.success--text {
  color: #26de81 !important;
}

.error--text {
  color: #fc5c65 !important;
}

/* Input fields */
::v-deep .v-text-field .v-input__slot {
  background: rgba(30, 30, 46, 0.5) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.2) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-text-field .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.4) !important;
}

::v-deep .v-input--is-focused .v-input__slot {
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.1) !important;
  background: rgba(30, 30, 46, 0.7) !important;
}

::v-deep .v-text-field__slot input {
  color: #e0e0e0 !important;
}

::v-deep .v-text-field__slot label {
  color: rgba(224, 224, 224, 0.6) !important;
}

::v-deep .v-input--is-focused .v-text-field__slot label {
  color: var(--v-secondary-base) !important;
}

::v-deep .v-input--is-focused .v-icon {
  color: var(--v-secondary-base) !important;
}

/* Loading */
::v-deep .v-progress-linear {
  border-radius: 8px;
}

::v-deep .v-progress-linear__background {
  background: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.1) !important;
}

::v-deep .v-progress-linear__determinate {
  background: var(--v-secondary-base) !important;
  box-shadow: 0 0 12px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.5);
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: var(--v-secondary-base);
  border-radius: 4px;
  transition: all 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  filter: brightness(1.2);
}

/* Animación */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
